import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-facility-tabs',
  templateUrl: './company-facility-tabs.component.html',
  styleUrls: ['./company-facility-tabs.component.css']
})
export class CompanyFacilityTabsComponent implements OnInit {
  defaultTabIndex: Number = 0;

  constructor() { }

  ngOnInit(): void {
  }

}
